import {shade, rgba} from "polished"

import {greys, primary, secondary, tertiary, utility, products} from "@irati/utils/uiTheme/colours"

import maxWidthMedia, {minWidthMedia} from "./media"

export const SHADE_MODIFIER = 0.8
export const HOVER_MODIFIER = 0.5
export const DARK_MODIFIER = 0.2
export const SHADOW_MODIFIER = 0.17

const dropShadowGrey = rgba(greys.grey50, SHADOW_MODIFIER)

export const perkboxBlue = primary.primary1

const gradients = {
  g1: `linear-gradient(67deg, ${primary.primary2} 0%, ${primary.primary1} 100%);`,
  g2: `linear-gradient(67deg, ${primary.primary1_200} 0%, ${primary.primary2} 100%);`,
  g3: `linear-gradient(67deg, ${primary.primary1} 0%, ${secondary.secondary1} 100%);`,
  g4: `linear-gradient(67deg, ${primary.primary2} 0%, ${secondary.secondary1} 100%);`,
  g5: `linear-gradient(67deg, ${secondary.secondary2} 0%, ${secondary.secondary1} 100%);`,
  jp: `linear-gradient(67deg, ${tertiary.j_400} 0%, ${tertiary.p_400} 100%);`,
  fp: `linear-gradient(67deg, ${tertiary.f_400} 0%, ${tertiary.p_400} 100%);`
}

const mainTheme = {
  colorFunctions: {
    // @todo: remove this + change usage in `apps/web/tour/src/components/styled.ts` to use pallet colours
    rgba
  },
  colors: {
    ...primary,
    ...secondary,
    tertiary,
    greys: {
      graphGrey: greys.grey03,
      lightest: greys.grey03,
      light: greys.grey12,
      mediumLight: greys.grey20,
      medium: greys.grey20,
      mediumDark: greys.grey50,
      dark: greys.grey50,
      disabled: greys.grey12,
      disabledText: greys.grey50,
      dropShadowGrey,
      ...greys
    },
    utility,
    gradients,

    brand: {
      default: primary.primary1,
      shade: `${shade(SHADE_MODIFIER, primary.primary1)}`,
      dark: `${shade(DARK_MODIFIER, primary.primary1)}`,
      hover: `${shade(HOVER_MODIFIER, perkboxBlue)}`
    },
    perkbox: {
      blue: primary.primary1,
      darkBlue: "#00678E",
      greenBlue: "#21A0A0"
    },
    products: {
      ...products
    },

    // TODO: REMOVE
    fontColor: greys.black,
    success: "#00BDB3",
    error: "#B30000",
    filterChip: "#2F3037",
    tooltip: "#1EBCB2"
  },
  spacing: {
    stepSize: 8,
    half: "4px",
    one: "8px",
    oneAndHalf: "12px",
    two: "16px",
    three: "24px",
    four: "32px",
    five: "40px",
    six: "48px",
    seven: "56px",
    eight: "64px",
    nine: "72px",
    ten: "80px",
    eleven: "88px",
    twelve: "96px"
  },
  font: {
    light: "WorkSansLight, sans-serif",
    default: "WorkSans, sans-serif",
    medium: "WorkSansMedium, sans-serif",
    semibold: "WorkSansSemibold, sans-serif",
    bold: "WorkSansBold, sans-serif"
  },
  border: {
    radius: {
      small: "2px",
      medium: "4px",
      large: "8px",
      extraLarge: "12px"
    }
  },
  shadows: {
    low: "1px 2px 5px 0 rgba(0,0,0,0.1)",
    mid: "1px 3px 10px 0 rgba(0,0,0,0.1)",
    high: "1px 3px 20px 0 rgba(0,0,0,0.1)",
    focus: "0 0 4px 0 rgba(4,150,255,0.8)",
    above: {
      low: "-1px -2px 5px 0 rgba(0,0,0,0.1)",
      mid: "-1px -3px 10px 0 rgba(0,0,0,0.1)",
      high: "-1px -3px 20px 0 rgba(0,0,0,0.1)"
    },
    inset: {
      low: "inset 1px 2px 5px 0 rgba(0,0,0,0.1)",
      mid: "inset 1px 3px 10px 0 rgba(0,0,0,0.1)",
      high: "inset 1px 3px 20px 0 rgba(0,0,0,0.1)"
    }
  },
  mediaQueries: {
    maxWidthMedia,
    minWidthMedia
  }
}

export default mainTheme
